import React from "react";
import clsx from "clsx";
import { useFormContext, useWatch } from "react-hook-form";
import { BusinessReport } from "@/modules/snapshots/businessReports.types";
import { InjectVariablesModalFormInputs } from "./index";
import { injectVariable } from "./helpers";

interface InjectVariablesModalRowProps {
  variable: string;
  businessReport: BusinessReport;
}

export const InjectVariablesModalRow: React.FC<InjectVariablesModalRowProps> = ({ variable, businessReport }) => {
  const {
    formState: { errors },
    register,
    control,
  } = useFormContext<InjectVariablesModalFormInputs>();

  const newVariables = useWatch({ control });

  const prompts = businessReport.prompts.filter(({ prompt }) => prompt.includes(`{${variable}}`));

  return (
    <div className="mb-2 rounded-md border border-gray-300 px-3 py-2 text-sm">
      {prompts.map(prompt => (
        <div key={prompt.id} className="mb-2 text-gray-400">
          {injectVariable(prompt.prompt, newVariables)}
        </div>
      ))}
      <div className="mb-3 flex justify-between">
        <div className="mt-2 font-medium">{variable}</div>
        <div>
          <input
            type="text"
            {...register(variable, { required: "This is required." })}
            className={clsx("rounded-md border bg-background px-3 py-2 text-sm", {
              "border-red-500": !!errors[variable],
            })}
          />
          {!!errors[variable] && <p className="mt-2 text-sm text-red-500">{errors[variable]?.message}</p>}
        </div>
      </div>
    </div>
  );
};
